const REGISTER_ERROR = 'registerError_' as const
const SDK_CONTEXT = Object.freeze({
  EXTENSION: 'extension',
  DEFAULT: 'default',
} as const)
export {REGISTER_ERROR, SDK_CONTEXT}
